import { render } from "./CorporatePartners.vue?vue&type=template&id=2a71b72c&scoped=true"
import script from "./CorporatePartners.vue?vue&type=script&lang=js"
export * from "./CorporatePartners.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2a71b72c"

export default script